import { Car, ChevronRight, Phone, Zap } from "lucide-react";
import React from "react";
import { motion, AnimatePresence } from 'framer-motion';
import { Navigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";




const YellowSection = () => {


    const handleclick=()=>{
    Navigate('/booking-form');
  }
    return (
            <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-yellow-400 via-yellow-400 to-yellow-400">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              className="text-left"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-gray-900 px-4 py-2 rounded-full text-sm font-semibold mb-6 border border-white/30">
                <Zap className="w-4 h-4" />
                Get 5% Off Your First Ride
              </div>
              
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Ready to Experience Premium Travel?
              </h2>
              
              <p className="text-xl text-gray-560 mb-8 leading-relaxed">
                Join thousands of satisfied customers who trust us for their transportation needs. Book now and travel with confidence.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
  {/* Book Your Ride - WhatsApp Button */}
  <motion.a
    href="https://wa.me/917349519354?text=Hello!%20I'm%20interested%20in%20booking%20a%20cab.%20Can%20you%20please%20provide%20more%20information%3F"
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{ scale: 1.02, y: -2 }}
    whileTap={{ scale: 0.98 }}
    className="bg-[#25D366] text-white px-8 py-4 rounded-2xl font-bold text-lg shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center gap-3 group cursor-pointer"
  >
    <FaWhatsapp className="w-5 h-5" />
    Book Your Ride
    <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
  </motion.a>
  
  {/* Call Us Now - Phone Dialer */}
  <motion.a
    href="tel:+917349519354"
    whileHover={{ scale: 1.02 }}
    whileTap={{ scale: 0.98 }}
    className="border-2 border-white/40 text-white px-8 py-4 rounded-2xl font-semibold text-lg hover:bg-white/10 backdrop-blur-sm transition-all duration-300 flex items-center justify-center gap-3 cursor-pointer"
  >
    <Phone className="w-5 h-5" />
    Call Us Now
  </motion.a>
</div>
            </motion.div>

            <motion.div
              className="grid grid-cols-2 gap-6"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {[
                { label: "Safe & Secure", value: "100%" },
                { label: "On-time Arrival", value: "98%" },
                { label: "Customer Satisfaction", value: "99%" },
                { label: "Ride Completion", value: "100%" }
              ].map((item) => (
                <motion.div 
                  key={item.label} 
                  className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-colors"
                  whileHover={{ scale: 1.05 }}
                >
                  <div className="text-3xl font-bold text-white mb-2">{item.value}</div>
                  <div className="text-blue-50 text-sm font-medium">{item.label}</div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

    );
}

export default YellowSection;